import React from 'react';
import DisputesRoutes from '@routes/inside/disputes';
import App from './app';

const path = '/:merchant_id(\\d+)';

const AppWithDisputesRoutes = (props: any) => <App routes={DisputesRoutes(path)} {...props} />;

export default AppWithDisputesRoutes;
